// Main store exports
export * from "./useFormServiceStore";
export * from "./useCatsStore";
export * from "./useCustomerStore";
export * from "./useDiscountStore";
export * from "./useOptimizeStore";
export * from "./usePopoverMenuStore";
export * from "./usePurchaseStore";
export * from "./useUserStore";
export * from "./useAvailableSubscriptionsStore";
export * from "./useToastNotificationsStore";

// Popover menu related exports
export * from "./usePopoverMenuStore.types";
export * from "./usePopoverMenuStore.constants";
export * from "./usePopoverMenuStore.utils";

// Error store exports
export * from "./error";

// TanStack stores
export * from "./tanstack/filters/filters.config";
export * from "./tanstack/filters/filters.schema";
export * from "./tanstack/filters/filters.store";
export * from "./tanstack/filters/filters.utils";
export * from "./tanstack/filters/useFiltersStore";
export * from "./tanstack/filters/useFiltersUrlSync";

// Legacy type alias for SUF v1 checkout consumers (confirmIntent, etc.)
export type { TAddressFormData as IAddressFormData } from "@./suf-store";

// Signup flow exports
export * from "./flows/fresh/signupFlow/signupFlowStore.types";
export * from "./flows/fresh/signupFlow/constants";
export * from "./flows/fresh/signupFlow/featureFlags";
export * from "./flows/fresh/signupFlow/utils";
export * from "./flows/fresh/signupFlow/hooks";
export * from "./flows/fresh/signupFlow/validation";

// shared
export * from "./flows/shared/storeHelpers";
export * from "./flows/shared/baseStore.types";
export * from "./flows/shared/hooks/useFreshTrialRecipes";

// Direct sales signup flow exports
export * from "./flows/fresh/directSales/types";
export * from "./flows/fresh/directSales/constants";
export * from "./flows/fresh/directSales/hooks";
export * from "./flows/fresh/directSales/utils";
export * from "./flows/fresh/directSales/validation";
